import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBottle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bottle, wine, campaign"} maskId="square-filled-radius-0-stroke-1-IconBottle"><path d="M9.5 1V2H10V7.25L6 10.25V23H18V10.25L14 7.25V2H14.5V1H9.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBottle;
